import React from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'

const Card3 = ({ className, children, ...props }) => (
  <Panel className={className} {...props}>
    {children}
  </Panel>
)

Card3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

Card3.defaultProps = {}

export default Card3
